import { render, staticRenderFns } from "./embeddedPopup.vue?vue&type=template&id=861bd69e&scoped=true&"
import script from "./embeddedPopup.vue?vue&type=script&lang=ts&"
export * from "./embeddedPopup.vue?vue&type=script&lang=ts&"
import style0 from "./embeddedPopup.vue?vue&type=style&index=0&id=861bd69e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861bd69e",
  null
  
)

export default component.exports